<template>
  <div ref="wrapper" class="wraper" style="height: 100%;">
    <navWrap v-if="!ismobile" @showLogin="loginItemShow"></navWrap>
	<mobileNav v-else @showLogin="loginItemShow"></mobileNav>
    <!-- <loginWrap @close="closeItem" v-if="showItem"></loginWrap> -->
	<div class="content">
		<router-view/>
	</div>
	<!-- <bottom-wrap v-if="$route.path !== '/login'&&$route.path !== '/resetPass'"></bottom-wrap> -->
    <!-- <div class="backTop" @click="backTop()">
      <i class="el-icon-arrow-up" style="font-weight: bold;"></i>
    </div>
    <div class="backBottom" @click="toBottom()">
      <i class="el-icon-arrow-down" style="font-weight: bold;"></i>
    </div> -->
  </div>
</template>

<script>
import { getIsTrial, getToken } from '@/utils/auth'
import navWrap from '@/layout/components/navWrap'
import mobileNav from '@/layout/components/mobileNav'
import loginWrap from '@/views/login/index.vue'
import bottomWrap from '@/layout/components/bottomWrap'
import router from '@/router'

var topCount = 1
var bottomCount = 1
export default {
  components: {
    loginWrap,
	navWrap,
	mobileNav,
	bottomWrap
  },
  data () {
    return {
      showItem: 0,
	  ismobile: false
    }
  },
  methods: {
	loginItemShow(val){
		this.showItem = val
	},
	closeItem(val){
		this.showItem = val
	},
    backTop () {
      topCount = 1
      this.toTopStep(50)
    },
    toTopStep (h) {
      document.documentElement.scrollTop -= h
      if (document.documentElement.scrollTop > 0) {
        if (document.documentElement.scrollHeight > 3000) {
          if (topCount <= 20) {
            var c = setTimeout(() => this.toTopStep(200), 16)
          } else {
            clearTimeout(c)
            document.documentElement.scrollTop = 0
          }
          topCount++
        } else {
          var c = setTimeout(() => this.toTopStep(50), 16)
        }
      } else {
        clearTimeout(c)
      }
    }
  },
  async mounted () {
    if(window.innerWidth<768) this.ismobile = true
  },

}
</script>

<style lang="scss">
html, body {
  height: 100%;
}

.app-main {
  width: 100%;
  min-height: 100vh;
  // padding: 30px 30px;
  padding-bottom: 30px;
  padding-right: 20px;
  // overflow-y: scroll;
  display: flex;

  .content {
    width: 100%;
    min-width: calc(100% - 320px);
    // min-height: $contentHeight;
    margin-left: 20px;
  }
}

.backTop {
  width: 40px;
  height: 40px;
  border-radius: 5px;
  line-height: 40px;
  text-align: center;
  color: #999aaa;
  position: fixed;
  right: 10px;
  bottom: 50px;
  z-index: 99;
  cursor: pointer;
  font-size: 20px;
  background-color: #fff;
  box-shadow: 0 0 6px rgba(0, 0, 0, .12);
  margin-bottom: 10px;
}

.backBottom {
  z-index: 99;
  cursor: pointer;
  position: fixed;
  right: 10px;
  border-radius: 5px;
  bottom: 0px;
  width: 40px;
  height: 40px;
  line-height: 40px;
  text-align: center;
  color: #999aaa;
  background-color: #fff;
  // border-radius: 50%;
  margin-bottom: 10px;
  box-shadow: 0 0 6px rgba(0, 0, 0, .12);
  font-size: 20px;
}
</style>
